
import { IBatchInfo } from 'components/common/DataGridDevEx/DataGrid.properties';
import { toObjectified } from 'api/baseApi';
import { Payload, useFetchMutation } from 'api/reactQuery/queryService';
import { Inline, objectify } from 'api/utils';
import { APIRoutes } from './constants';

// RETRIEVE TRANSACTIONS LINES
export type IRetrieveTransactionsLinesPayload = Payload<{ MovementId: number; ProductId: number }, IBatchInfo>;

const transactionsLinesResponseParser = (response): any => {
    const { Transactions } = response;

    return {
        ...response,
        Transactions: Transactions.map((o) => objectify(o as Inline<any>))
    };
};

export const useRetrieveTransactionsLines = () =>
    useFetchMutation<IRetrieveTransactionsLinesPayload, any>
        (APIRoutes.movementEnquiry.transactions.lines.retrieve, null, { inline: true, responseParser: transactionsLinesResponseParser });

// RETRIEVE BIN LOCATIONS LINES
export type IRetrieveBinLocationsLinesPayload = Payload<{ MovementId: number; ProductId: number; LineNumber: number }, IBatchInfo>;

const binLocationsLinesResponseParser = (response): any => {
    const { Bins } = response;

    return {
        ...response,
        Bins: Bins.map((o, index) => ({
            ...objectify(o as Inline<any>),
            UID: index,
        })),
    };
};

export const useRetrieveBinLocationsLines = () =>
    useFetchMutation<IRetrieveBinLocationsLinesPayload, any>
        (APIRoutes.movementEnquiry.binLocation.lines.retrieve, null, { inline: true, responseParser: binLocationsLinesResponseParser });

// RETRIEVE LOT LINES
export type IRetrieveLotLinesPayload = Payload<{ MovementId: number; ProductId: number; LineNumber: number }, IBatchInfo>;

const lotLinesResponseParser = (response): any => {
    const { Lots } = response;

    return {
        ...response,
        Lots: Lots.map((o) => objectify(o as Inline<any>))
    };
};

export const useRetrieveLotLines = () =>
    useFetchMutation<IRetrieveLotLinesPayload, any>
        (APIRoutes.movementEnquiry.lot.lines.retrieve, null, { inline: true, responseParser: lotLinesResponseParser });

// RETRIEVE SERIAL LINES
export type IRetrieveSerialLinesPayload = Payload<{ MovementId: number; ProductId: number; LineNumber: number }, IBatchInfo>;

const serialLinesResponseParser = (response): any => {
    const { Serials } = response;

    return {
        ...response,
        Serials: Serials.map((o) => objectify(o as Inline<any>))
    };
};

export const useRetrieveSerialLines = () =>
    useFetchMutation<IRetrieveSerialLinesPayload, any>
        (APIRoutes.movementEnquiry.serial.lines.retrieve, null, { inline: true, responseParser: serialLinesResponseParser });

// RETRIEVE MOVEMENT SUMMARY
export type IRetrieveMovementSummaryPayload = Payload<{ MovementId: number; ProductId: number; LineNumber: number }>;

const movementSummaryResponseParser = (response): any => {
    const { StockingMovement } = response;

    return {
        ...response,
        StockingMovement: toObjectified(StockingMovement as Inline<any>)
    };
};

export const useRetrieveMovementSummary = () =>
    useFetchMutation<IRetrieveMovementSummaryPayload, any>
        (APIRoutes.movementEnquiry.summary.retrieve, null, { inline: true, responseParser: movementSummaryResponseParser });
